var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 3.51469C18.2188 1.24823 15.2053 0 12 0C8.79469 0 5.78123 1.24823 3.51469 3.51469C1.24823 5.78123 0 8.79469 0 12C0 14.1143 0.554812 16.1827 1.60716 18.0019L0 24L5.99808 22.3928C7.8173 23.4452 9.8857 24 12 24C15.2053 24 18.2188 22.7518 20.4853 20.4853C22.7518 18.2188 24 15.2053 24 12C24 8.79469 22.7518 5.78123 20.4853 3.51469ZM12 22.5938C10.0427 22.5938 8.13061 22.0556 6.47039 21.0375L6.21277 20.8795L1.98872 22.0113L3.12056 17.7873L2.96259 17.5297C1.94438 15.8694 1.40625 13.9573 1.40625 12C1.40625 6.15858 6.15858 1.40625 12 1.40625C17.8414 1.40625 22.5938 6.15858 22.5938 12C22.5938 17.8414 17.8414 22.5938 12 22.5938Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 16.5703H11.2969V17.9766H12.7031V16.5703Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.02344C10.0615 6.02344 8.48438 7.60055 8.48438 9.53906H9.89062C9.89062 8.37595 10.8369 7.42969 12 7.42969C13.1631 7.42969 14.1094 8.37595 14.1094 9.53906C14.1094 10.0585 13.9186 10.5577 13.5719 10.9451L11.2969 13.4893V15.1641H12.7031V14.0264L14.6199 11.8828C15.1975 11.2373 15.5156 10.4051 15.5156 9.53906C15.5156 7.60055 13.9385 6.02344 12 6.02344Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.d348d50a.svg";
export { ForwardRef as ReactComponent };